module.exports = "pegasus_template/assets/column-2-basic.png";